export const messages = {
  header: {
    id: "signup.header",
    defaultMessage: "Welcome to Bible Engagement Project",
  },
  title: {
    id: "signup.title",
    defaultMessage: "Create an Account",
  },
  name: {
    id: "signup.name",
    defaultMessage: "Name",
  },
  email: {
    id: "signup.email",
    defaultMessage: "Email",
  },
  password: {
    id: "signup.password",
    defaultMessage: "Password",
  },
  churchName: {
    id: "signup.church-name",
    defaultMessage: "Church Name",
  },
  churchRole: {
    id: "signup.church-role",
    defaultMessage: "Role in church",
  },
  preferredLanguage: {
    id: "signup.preferred-language",
    defaultMessage: "Preferred language: {{value}}",
  },
  buttonNext: {
    id: "signup.button-next",
    defaultMessage: "Next",
  },
  buttonCreate: {
    id: "signup.button-create",
    defaultMessage: "Get started",
  },
  errorEmail: {
    id: "signup.error-email",
    defaultMessage: "Incorrect email",
  },
  errorEmailInUse: {
    id: "signup.error-email-in-use",
    defaultMessage: "This email is already in use",
  },
  errorPassword: {
    id: "signup.error-password",
    defaultMessage: "Incorrect password",
  },
  hintPassword: {
    id: "signup.hint-password",
    defaultMessage: `Password must be at least 8 characters and include: a capital, a lowercase, a special character, and a number`,
  },
  weakPassword: {
    id: "signup.weak-password",
    defaultMessage: "Password should be at least 6 characters",
  },
  enLanguage: {
    id: "signup.language-en",
    defaultMessage: "English",
  },
  esLanguage: {
    id: "signup.language-es",
    defaultMessage: "Spanish",
  },
  cancel: {
    id: "signup.cancel",
    defaultMessage: "Cancel",
  },
};
